
import React, { useState, useEffect,useContext } from "react";
import { useRouteMatch } from "react-router-dom";
import TopbarStyles from './Topbar.module.css';
import ProfileDropdown from 'components/Content/Dropdown/ProfileDropdown';
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";

import ErrorDialog from "components/Content/Modal/ErrorDialog";
import FeedbackDialog from "components/Content/Modal/FeedbackDialog";
import ClientAcknowledgementDialog from "components/Content/Modal/Acknowledgements/ClientAcknowledgementDialog";
import DeliverablesAndServicesAcknowledgementDialog from "components/Content/Modal/Acknowledgements/DeliverablesAndServicesAcknowledgementDialog";
import BRDAcknowledgementDialog from "components/Content/Modal/Acknowledgements/BrdAcknowledgementDialog";

import pendo from "pendo";

import QuickLinks from "./QuickLinks"
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import config from 'config'

import { Utils } from "common/Utils";

const defaultURI = `${config.apiGateway.URL}/${config.apiGateway.DEFAULT_VERSION}`;

function Topbar(props) {
    const { path } = useRouteMatch();
    const { companyId, insuredId, currentPortal, usesEase, usesTpa, error, acknowledgement, feedback, userInfo } = useContext(PrivateRoutesContext);
    const [name, setName] = useState("");

    const [deferredAcks, setDeferredAcks] = useState("");

    const displayEase = (override) =>{
        return usesEase || override;
    }
    const displayTpa = (override) =>{
        return usesTpa || override;
    }

    useEffect(() => {
        let loginName = localStorage.getItem("loginName");

        if (loginName == null) {
            apiGet(apiUrls.getMe).then((response) => {
                localStorage.setItem("loginName", response.data);
                setName(response.data);
              });
        }
        else {
            setName(loginName);
        }

      }, [name]);

    useEffect(() => {
        switch (currentPortal) {
            case "EMPLOYER":
                pendo.initialize(companyId);

                getAcknowledgements();
                break;
            case "EMPLOYEE":
                pendo.initialize(insuredId);

                acknowledgement.setAcknowledgements(null);
                break;
        }

        var da = localStorage.getItem("deferredAcks");
        setDeferredAcks(da);
      }, [currentPortal, companyId, insuredId]);

    useEffect(() => {
        acknowledgement.setDoShowClientAcknowledgement(false);
        acknowledgement.setDoShowDeliverablesAcknowledgement(false);
        acknowledgement.setDoShowBRDAcknowledgement(false);

        localStorage.setItem("deferredAcks", deferredAcks);

        var isEmployer = Utils.isEmployer(userInfo);

        if (acknowledgement.acknowledgements && isEmployer) {
            if (acknowledgement.acknowledgements.implementation && !acknowledgement.acknowledgements.implementation.date && !deferredAcks.includes(acknowledgement.acknowledgements.implementation.documentId)) {
                acknowledgement.setDoShowClientAcknowledgement(true);
            } else if (acknowledgement.acknowledgements.service && !acknowledgement.acknowledgements.service.date && !deferredAcks.includes(acknowledgement.acknowledgements.service.documentId)) {
                acknowledgement.setDoShowDeliverablesAcknowledgement(true);
            } else if (acknowledgement.acknowledgements.brd && !acknowledgement.acknowledgements.brd.date && !deferredAcks.includes(acknowledgement.acknowledgements.brd.documentId)) {
                acknowledgement.setDoShowBRDAcknowledgement(true);
            }
        }
    },[acknowledgement.acknowledgements, deferredAcks, userInfo]);

    const getAcknowledgements = () => {
        apiGet(apiUrls.getAcknowledgements(companyId))
            .then(response => {
                if (response.data) {
                    acknowledgement.setAcknowledgements(response.data);
                }
            })
            .catch(response => {
                
            })
            .finally(() => {
                
            })
    }

    const postAcknowledgement = (documentId, isAcked, finallyAction) => {
        apiPost(apiUrls.postAcknowledgement(companyId, documentId, isAcked))
            .then(response => {
                if (response.data) {
                    acknowledgement.setAcknowledgements(response.data);
                }
            })
            .catch(response => {
                
            })
            .finally(() => {
                if (finallyAction) {
                    finallyAction();
                }

                if (!deferredAcks.includes(documentId)) {
                    var newDeferredAcks = deferredAcks.length > 0 ? `${deferredAcks},${documentId}` : `${documentId}`;

                    setDeferredAcks(newDeferredAcks);
                }
            })
    }
    const showLogo = () => {
        return !(path.includes("/ap3") || path.includes("/cui") )
    }
    return (
        <div className={TopbarStyles.topbarWrapper}>
            <div className="d-inline-flex">
                { (showLogo() && companyId?.length > 0) ? <img src={`${apiUrls.getLogo(companyId, "rect")}`} alt="company logo" style={{maxWidth:"250px", maxHeight:"53px", marginRight:"25px"}} /> : null }
                <div className={TopbarStyles.pageTitle}>
                    {props.title}
                </div>
            </div>
            <QuickLinks ease={displayEase(props.displayEase)} tpa={displayTpa(props.displayTpa)}/>
            <ProfileDropdown name={name} />
            <ErrorDialog doShowError={error.doShowError} handleErrorClose={() => error.setDoShowError(false)} errorTitle={error.title} errorText={error.text} />
            <FeedbackDialog doShow={feedback.doShow} feedbackType={feedback.type} feedbackSubject={feedback.subject} />
            {acknowledgement.acknowledgements ?
                <>
                    <ClientAcknowledgementDialog
                        doShow={acknowledgement.doShowClientAcknowledgement}
                        acknowledgement={acknowledgement.acknowledgements.implementation}
                        handleSubmit={(isAcked, finallyAction) => postAcknowledgement(acknowledgement.acknowledgements.implementation.documentId, isAcked, finallyAction) }
                        handleClose={() => acknowledgement.setDoShowClientAcknowledgement(false)}
                    />
                    <DeliverablesAndServicesAcknowledgementDialog
                        doShow={acknowledgement.doShowDeliverablesAcknowledgement}
                        acknowledgement={acknowledgement.acknowledgements.service}
                        handleSubmit={(isAcked, finallyAction) => postAcknowledgement(acknowledgement.acknowledgements.service.documentId, isAcked, finallyAction)}
                        handleClose={() => acknowledgement.setDoShowDeliverablesAcknowledgement(false)}
                    />
                    <BRDAcknowledgementDialog
                        doShow={acknowledgement.doShowBRDAcknowledgement}
                        acknowledgement={acknowledgement.acknowledgements.brd}
                        handleSubmit={(isAcked, finallyAction) => postAcknowledgement(acknowledgement.acknowledgements.brd.documentId, isAcked, finallyAction)}
                        handleClose={() => acknowledgement.setDoShowBRDAcknowledgement(false)}
                    />
                </>
            : null}
        </div>
    )
}

export default Topbar
